const AuthorSex = Object.freeze({
  UNKNOWN: 'Unknown',
  FEMALE: 'F',
  MALE: 'M'
})
export default AuthorSex
export type AuthorSexStrings = typeof AuthorSex[keyof typeof AuthorSex]
// RESERVE BELOW
